<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 flex justify-between mb-6">
      <span class="text-[#2d82b5] font-semibold">
        TOEFL for {{ data.full_name }}
      </span>
      <span class="text-sm">
        {{ $t("common.student_id") }}:
        <span class="font-semibold">{{ data.student_code }}</span>
        <span class="ml-4">
          {{ $t("common.grade") }}:
          <span class="font-semibold">{{ data.grade }}</span>
        </span>
      </span>
    </div>

    <div class="md-layout-item md-size-100 mb-3">
      <chart :data-detail="data"></chart>
    </div>

    <div class="md-layout-item md-size-100">
      <div class="flex justify-between mb-3">
        <span class="font-medium">
          {{ $t("smi_sri.detail_about_tests") }}
        </span>
        <span class="text-right text-red-600 text-sm">
          {{ $t("smi_sri.super_score") }}:
          <span class="font-medium">{{ data.super_score }}</span>
        </span>
      </div>

      <md-table class="table-pdf-assessment">
        <md-table-row class="text-center">
          <md-table-cell>{{ $t("smi_sri.test_name") }}</md-table-cell>
          <md-table-cell>{{ $t("smi_sri.test_date") }}</md-table-cell>
          <md-table-cell>{{ $t("smi_sri.total_score") }}</md-table-cell>
          <md-table-cell>Listening</md-table-cell>
          <md-table-cell>Reading</md-table-cell>
          <md-table-cell>Writing</md-table-cell>
          <md-table-cell>Speaking</md-table-cell>
        </md-table-row>

        <md-table-row
          class="text-center"
          v-for="(row, index) in data.toefl"
          :key="row.test_name + index"
        >
          <md-table-cell>{{ row.test_name }}</md-table-cell>
          <md-table-cell>{{
            convertDateFromServer(row.test_date, "date")
          }}</md-table-cell>
          <md-table-cell>{{ row.total_score }}</md-table-cell>
          <md-table-cell>{{ row.listening }}</md-table-cell>
          <md-table-cell>{{ row.reading }}</md-table-cell>
          <md-table-cell>{{ row.speaking }}</md-table-cell>
          <md-table-cell>{{ row.writing }}</md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>
<script>
import Chart from "./Chart";
import { convertDateFromServer } from "@/helpers/datetime-helper";

export default {
  name: "export-pdf-toefl",
  components: { Chart },
  props: ["data"],
  data() {
    return {
      convertDateFromServer
    };
  }
};
</script>
